<template>
  <div
    v-title
    title="商品评价"
    class="overwrite_productPingjia"
    style="
      height: 94vh;
      overflow-y: auto;
      overflow-x: hidden;
      background-color: #f7f8fa;
    "
  >
    <!--<van-nav-bar-->
    <!--title="商品评价"-->
    <!--@click-left="onClickLeft">-->

    <!--<span slot="left">-->
    <!--<van-icon name="arrow-left" color="#323233" size="20" />-->
    <!--</span>-->
    <!--<span slot="right">-->
    <!--<van-icon name="share-o" @click="test1"  color="#323233" size="20"/>-->

    <!--<van-icon name="ellipsis"@click="test2" color="#323233" size="20"/>-->
    <!--</span>-->
    <!--</van-nav-bar>-->

    <van-tabs @click="changeTab" v-model="active">
      <van-tab title="全部"></van-tab>
      <van-tab>
        <span slot="title"> 好评({{ dataCount.betterCnt }}) </span>
      </van-tab>
      <van-tab>
        <span slot="title"> 中评({{ dataCount.middleCnt }}) </span>
      </van-tab>
      <van-tab>
        <span slot="title"> 差评({{ dataCount.badCnt }}) </span>
      </van-tab>
    </van-tabs>

    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="loadComment"
    >
      <div class="width100" style="padding: 0 2vw; box-sizing: border-box">
        <van-cell v-for="item in dataList" :key="item.id" style="margin: 2vh 0">
          <div slot="title" class="flex-row">
            <div class="pingjia_title_box">
              <div class="product_img_center">
                <van-image
                  style="margin: 0 auto"
                  round
                  width="4rem"
                  height="4rem"
                  :src="item.memberIcon"
                />
              </div>
              <div class="font15rem" style="padding-left: 5px">
                <div style="padding-top: 0.3vh">
                  {{ formatNickName(item.memberNickName) }}
                </div>
                <div class="font-pain-grey" style="font-size: 1rem">
                  {{ getProductAttrDesc(item) }} |
                  {{ formatDate(item.createTime, 'yyyy-MM-dd') }}
                </div>
              </div>
            </div>
          </div>
          <div
            slot="label"
            class="font_normal_grey font15rem"
            style="padding-top: 1vh"
          >
            {{ item.content }}
          </div>
        </van-cell>
      </div>
    </van-list>

    <van-goods-action>
      <van-goods-action-icon
        @click="kefushow = !kefushow"
        icon="service"
        text="客服"
      />
      <van-goods-action-icon @click="goHome" icon="wap-home" text="首页" />

      <div
        slot="default"
        style="width: 100vw; text-align: right; padding-right: 1rem"
      >
        <van-button
          @click="next"
          size="normal"
          color="linear-gradient(to right, #ff6034, #ee0a24)"
        >
          立即购买
        </van-button>
      </div>
    </van-goods-action>

    <van-action-sheet v-model="kefushow" title="客服">
      <div
        class="width100 text-center"
        style="font-size: 1.5rem; padding: 2rem 0"
      >
        商家名称: {{ shop.invoiceProvideCompany }}
      </div>
      <div
        @click="phoneNumber"
        class="kefubtn text-center"
        style="margin-top: 2rem"
      >
        <div style="font-size: 1.5rem">客服电话</div>
        <div style="font-size: 12px">
          服务时间 {{ shop.customerServiceTime }}
        </div>
      </div>
      <div
        @click="phoneNumber2"
        class="kefubtn text-center"
        style="margin-top: 4rem; margin-bottom: 10rem"
      >
        <div style="font-size: 1.5rem">在线客服</div>
        <div style="font-size: 12px">服务时间 {{ shop.onlineServiceTime }}</div>
      </div>
    </van-action-sheet>

    <div
      ref="maidian"
      td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/pingjiaList"
    ></div>
  </div>
</template>

<script>
import { post } from 'api/post'
import { get } from 'api/get'

export default {
  name: 'CommentList',
  props: ['productId'],
  data() {
    return {
      active: 0,
      kefushow: false,
      shop: {
        invoiceProvideCompany: '',
        customerServicePhone: '',
        customerServiceTime: '',
        onlineServiceTime: '',
      },
      searchForm: {
        productId: '',
        starStatus: '',
        pageNum: 1,
        pageSize: 6,
      },
      dataCount: {
        betterCnt: 0,
        middleCnt: 0,
        badCnt: 0,
      },
      dataList: [
        {
          id: '',
          memberIcon: '',
          memberNickName: '',
          productAttr: '',
          createTime: '',
          content: '',
        },
      ],
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  components: {},
  watch: {},
  created() {
    /*if (this.$route.query.productId) {
                this.searchForm.productId = this.$route.query.productId
            }*/
    this.searchForm.productId = this.productId
    this.getCommentCount()
    this.getShopDetail()

    let self = this
    this.$nextTick(() => {
      self.$refs['maidian'].click()
    })
  },
  mounted() {},
  methods: {
    loadComment() {
      let self = this
      get(
        'productcomment/list/' + self.searchForm.productId,
        self.searchForm
      ).then((res) => {
        console.log(res)
        if (res.code === self.GLOBAL.SUCCESS) {
          let resData = JSON.parse(JSON.stringify(res.data))

          if (self.searchForm.pageNum == 1) {
            this.dataList = [] // 如果是第一页需手动置空列表
          }

          self.dataList = self.dataList.concat(resData.list) // 追加新数据

          // 分页数据加载完毕
          if (self.refreshing) {
            self.dataList = []
            self.refreshing = false
          }

          self.loading = false

          // 全部数据已加载完毕
          if (self.dataList.length >= resData.total) {
            self.finished = true
          } else {
            self.searchForm.pageNum = self.searchForm.pageNum + 1
          }
        } else {
          self.$dialog.alert({
            theme: 'round-button',
            message: res.message,
            confirmButtonColor: '#00754a',
          })
        }
      })
    },
    getCommentCount() {
      let self = this
      get('productcomment/listCnt/' + self.searchForm.productId).then((res) => {
        console.log(res)
        if (res.code === self.GLOBAL.SUCCESS) {
          self.dataCount = JSON.parse(JSON.stringify(res.data))
        } else {
          self.$dialog.alert({
            theme: 'round-button',
            message: res.message,
            confirmButtonColor: '#00754a',
          })
        }
      })
    },
    getShopDetail() {
      let self = this
      get('setting/sysParam/sys_shop_param').then((res) => {
        console.log(res)
        if (res.code === self.GLOBAL.SUCCESS) {
          let resData = JSON.parse(JSON.stringify(res.data))

          self.shop.invoiceProvideCompany = resData.find(
            (i) => i.dictLabel == '发票提供公司'
          ).dictValue
          self.shop.customerServicePhone = resData.find(
            (i) => i.dictLabel == '商城客服电话'
          ).dictValue
          self.shop.customerServiceTime = resData.find(
            (i) => i.dictLabel == '商城服务时间'
          ).dictValue
          self.shop.onlineServiceTime = resData.find(
            (i) => i.dictLabel == '商城在线服务时间'
          ).dictValue
        } else {
          self.$dialog.alert({
            theme: 'round-button',
            message: res.message,
            confirmButtonColor: '#00754a',
          })
        }
      })
    },
    getProductAttrDesc(data) {
      if (!data.productAttr) {
        return ''
      }

      // [{"key":"颜色","value":"紫色"},{"key":"容量","value":"4G"}]
      let jsonList = JSON.parse(data.productAttr)

      let array = []
      for (let i = 0; i < jsonList.length; i++) {
        array.push(jsonList[i].value)
      }

      return array.join(' ')
    },
    formatNickName(name) {
      if (!name) {
        return ''
      }

      let searchValue = /(.{1}).*(.{1})/
      let replaceValue = '$1***$2'
      if (name.length < 2) {
        searchValue = /(.{1}).*/
        replaceValue = '$1***'
      }

      return name.replace(searchValue, replaceValue)
    },
    formatDate: function (datestr, fmt) {
      let date = new Date(Date.parse(datestr.substring(0, 10)))

      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
      }
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + ''
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1 ? str : this.padLeftZero(str)
          )
        }
      }
      return fmt
    },
    padLeftZero: function (str) {
      return ('00' + str).substr(str.length)
    },
    onClickLeft() {
      this.$emit('closePopup')
    },
    test1() {},
    test2() {},
    changeTab() {
      if (this.active === 0) {
        this.searchForm.starStatus = ''
      } else if (this.active === 1) {
        this.searchForm.starStatus = 5
      } else if (this.active === 2) {
        this.searchForm.starStatus = 3
      } else if (this.active === 3) {
        this.searchForm.starStatus = 0
      }

      this.searchForm.pageNum = 1
      this.finished = false
      this.loading = true
      this.loadComment()
    },
    next() {
      this.$emit('next')
    },
    goHome() {
      this.$router.push('/')
    },
    phoneNumber() {
      window.location.href = 'tel://' + this.shop.customerServicePhone
    },
    phoneNumber2() {
      // window.location.href = this.$baseUrl3
      // this.$router.push("/help");
      // this.$refs.content2.click();
      document.getElementById('content').click()
    },
  },
}
</script>

<style scoped>
.pingjia_title_box {
  min-height: 6vh;
  display: flex;
  flex-direction: row;
}

.kefubtn {
  width: 80%;
  margin: 0 auto;
  padding-top: 0.5rem;
  box-sizing: border-box;
  height: 5rem;
  background: linear-gradient(to right, #ff6034, #ee0a24);
  color: #ffffff;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/product/pingjiaList.vue